import { render, staticRenderFns } from "./Serum.vue?vue&type=template&id=4c18c94f&scoped=true"
import script from "./Serum.vue?vue&type=script&lang=js"
export * from "./Serum.vue?vue&type=script&lang=js"
import style0 from "./Serum.vue?vue&type=style&index=0&id=4c18c94f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c18c94f",
  null
  
)

export default component.exports